export default __webpack_public_path__ + "static/media/idolofdarkrejuvenation.aa6b765d.png";